import type { Response } from 'express';
import moment from 'moment';
import { windowWrapper } from '@clubmed/utils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import {
  buildSigninUrl,
  buildErrorUrl,
  buildSellerSigninUrl,
  QUICK_LOGIN_QUERY_PARAM,
} from './index';
export const isTokenValid = (userInfo: UserInfo | null | undefined) =>
  userInfo && moment(userInfo.expirationDate, 'X').startOf('second').isAfter();
type HandleInvalidTokenParams = {
  appContext: AppContext;
  currentUri: URI;
  res: Response | null | undefined;
  userInfo: UserInfo | null | undefined;
};
export const handleInvalidToken = ({
  appContext,
  currentUri,
  res,
  userInfo,
}: HandleInvalidTokenParams) => {
  const { locale, isSeller, isCmta, isUserLogged, isUserQuickLogged, isSellerLogged } = appContext;
  const redirectUri = isSeller
    ? buildSellerSigninUrl({
        isCmta,
        locale,
        redirectUri: currentUri.toString(),
        redirectURIError: buildErrorUrl(currentUri.toString(), locale),
      })
    : buildSigninUrl({
        locale,
        redirectUri: currentUri.toString(),
        redirectURIError: buildErrorUrl(currentUri.toString(), locale),
        isQuickLoginFirst:
          currentUri.toString().includes(`provider=${QUICK_LOGIN_QUERY_PARAM}`) ||
          isFeatureFlipped(appContext)('memberSpace.isQuickLoginFirst'),
      });

  // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {
  if (!isUserLogged && !isUserQuickLogged && !isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      windowWrapper.setLocation(redirectUri);
    }
  } else if ((isUserLogged || isUserQuickLogged) && !isTokenValid(userInfo)) {
    windowWrapper.setLocation(redirectUri);
  }
};
